//tslint:disable:export-name
import { Container } from 'hypo-container';
import { ConfigStore } from './ConfigStore';
import { ServiceBusController } from './ServiceBusController';
import { VtoViewController } from '~controllers/VtoViewController';
import { VtoCTAButtonViewController } from '~controllers/VtoCTAButtonViewController';
import { VtoSkinCareViewController } from '~controllers/VtoSkinCareViewController';
import { getDecorators } from '@estee/elc-service';
import { QuizApiSdk } from '~api/QuizApiSdk';
import { PersonalizationApiSdk } from '~api/PersonalizationApiSdk';
import { SurveyApiSdk } from '~api/SurveyApiSdk';
import { QuizApiRepository } from '~repositories/QuizApiRepository';
import { IAppConfig, root } from '@estee/elc-universal-utils';
import { PersonalizationRepository } from '~repositories/PersonalizationRepository';
import { UserInfoRepository } from '~repositories/UserInfoRepository';
import { SurveyRepository } from '~repositories/SurveyRepository';
import serviceNames, { VtoService } from '~setup/VtoService';

export const diContainer = new Container();

export interface IServiceInfo {
    serviceName: string;
    serviceVersion: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setConfig = (configJSON: IAppConfig) => {
    diContainer.config = configJSON;
};

const { name: serviceName, version } = __serviceInfo__;

diContainer
    .register(
        serviceNames.configStore,
        diContainer.factory((c) => new ConfigStore(c.config))
    )
    .register(serviceNames.vtoService, (c) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new VtoService((config: any) => {
            setConfig(config);

            return c.get(serviceNames.serviceBusController);
        });
    })
    .register(serviceNames.serviceBusController, () => new ServiceBusController())
    .register(serviceNames.vtoViewController, (c) => {
        const serviceInfo: IServiceInfo = {
            serviceName,
            serviceVersion: version
        };

        return new VtoViewController(serviceInfo);
    })
    .register(serviceNames.vtoCTAButtonViewController, (c) => new VtoCTAButtonViewController())
    .register(serviceNames.vtoSkinCareViewController, (c) => new VtoSkinCareViewController())
    .register(serviceNames.httpTransport, (c) => {
        return root.HttpTransport;
    })
    .register(serviceNames.quizApiSdk, (c) => {
        return new QuizApiSdk(
            { httpTransport: c.get(serviceNames.httpTransport) },
            serviceName,
            version
        );
    })
    .register(serviceNames.personalizationApiSdk, (c) => {
        return new PersonalizationApiSdk(
            { httpTransport: c.get(serviceNames.httpTransport) },
            serviceName,
            version
        );
    })
    .register(serviceNames.quizApiRepository, (c) => {
        return new QuizApiRepository();
    })
    .register(serviceNames.personalizationRepository, (c) => {
        return new PersonalizationRepository(c.get(serviceNames.personalizationApiSdk));
    })
    .register(serviceNames.userInfoRepository, (c) => new UserInfoRepository(serviceName, version))
    .register(serviceNames.surveyApiSdk, (c) => {
        return new SurveyApiSdk(
            { httpTransport: c.get(serviceNames.httpTransport) },
            serviceName,
            version
        );
    })
    .register(
        serviceNames.surveyRepository,
        (c) => new SurveyRepository(serviceName, version, c.get(serviceNames.surveyApiSdk))
    );

const { lazyInject } = getDecorators(diContainer);

export { lazyInject };
